// SESSION
// "sessionToken": "eyJraWQiOiJcL0NuaW11N1JmYnB1a1QyVHp0Q3BYQ1hKUmt0bDJJd0hlUm5TWUFOdDcraz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIwZWE1ZGFhNC1mNTg3LTQ5MjEtYmY4Yy0zNzAwNWY2ZjQ3OWQiLCJkZXZpY2Vfa2V5IjoiZXUtY2VudHJhbC0xXzY0MThiZDNhLTI3N2UtNDNiNS04OGJlLTVjYTdjOThlMGY0YyIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC5ldS1jZW50cmFsLTEuYW1hem9uYXdzLmNvbVwvZXUtY2VudHJhbC0xX0xyblVyMEk1cSIsImNsaWVudF9pZCI6IjM3b3JjbXU2Y3U4bTBkOGFjYzR2bHFoaWUwIiwib3JpZ2luX2p0aSI6IjllOGM3YmExLWUzNjAtNGYzMy04OTI2LWE5OTYwNzM5YzNjZCIsImV2ZW50X2lkIjoiZTY4NGEzYjEtZGI5ZC00NmFmLWI2NTUtMGQ0NjI2YmJkYWFjIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTY1MzMyMzIyNSwiZXhwIjoxNjUzMzIzNTI1LCJpYXQiOjE2NTMzMjMyMjYsImp0aSI6IjYyNmJmOGQ2LWRhZGEtNDE2Ni1iYjczLTIxYzBlNjExOTAxMiIsInVzZXJuYW1lIjoiMGVhNWRhYTQtZjU4Ny00OTIxLWJmOGMtMzcwMDVmNmY0NzlkIn0.d84I2lozVxX2YkDb2bLhthBIybw053q7zaO3FnrpzIno8Cm-cuTe70GpjOtX2inOqOYUhavgzhgY9V3Szrxx18B7MVSLQeTKtD3HD2L_hh-_8zlfr4lNbktgTfXhxZ7fvaMzCIBQ_axEgYCflFhhspBpMbqSDjqki53pPEzBDcQL-OFcjT5N4hJs4-OQQoCXh7S_sWGzmTnQ3ux8BXWCleFzRvhBiWecnnVhFkCYA897AY1nNNO7dhvNSDiTlv-_TxP6IXIU5MsVIUoi6HW6p8yTsz-23yZFUV-THC7sbAPAn6Uf84hR2psc0R62mYvKiQ2JiLBujn_h039JCkFoww",
// "refreshToken": "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.lhuNpt8_e3iIORmgXXKq2zHhKQbtuinbtalsaXBGGx_wNPncyuDpw7k0PG0Nl_NJ_rCHSaETxlb6GKzu3NJXn_e56dVy7jZM6jpQ4o6VGA5g5zcwduu-8ByugczbufMoRxQjlJtciAZRiPkTMHbC-MXuWmVV3XoOAOYCWvXHo-LmIyR3MfpQSvwde3XZrVtJDsAmkG6XzCOx5JoDfBNcrF9Z5stXDuoMK4lUlbyv9aJ__6NdOQ6lfgMqQhyN6NATG2wJ5WtM7QBI6BNbezTNmf3uz7HJXsP9ZrxKlf8uyoRRrUV8OT-EY8hn289Ya3lRfY31yPZB9p0LYgbHfLPKzw.yNzUk03qxTF0pvqS.AIOHibPHemlc3r1P7dVw6PRDRev812omHKbLuK2lzf6heFbd93Dws9oMg8bbSwW45wUpXH2vJuUacF9MdgqNW_LKwJXjIkK8rsive0EDqLL0S-5RD6w93LESlTuRRIT4zmSK4iMBWB3PyP6sEL0FuRM9CGlyKiBFce5qeDF1U4DPZz-Qj9ACa-OSyHorIQhvKuGXN_k6ctd8u7nbgyXWKhjv-LnDOqRKxEsOe7MhTlr0ibeh6nAKZXuLn5e-K099Z49AX6c6uXl1LXfRuKGCX8GOazsz5jZXRJNMCA6pleAvsBWWYK5rFxK67KhiPgnjcsHREJIo-xnTgYZZmazjhM8rbZKkuWMBYTxLFABGZODgd-PSAh0h5Ucm8Luu4VZCU7WNeptDBvI2VDlNkUG0-zqDWHl-nxx4rDd54RdMmlZubFkycbOSsfrqFGGxR28QQQd0hfFKj9HEX_-8HBl9gVWSOQ34d5iPEk2JpZmqa37PimB9s4eFq8MiD3ru1HpX4ZgMsS0qwxLaSBfs2wNdFqCJfvTzTxhHqOKPCd4IuMcVJ_zyn8NCgwHXYkN8T1GVVYPNvc_HctdSf7laJhmd91ymCAXDCQMdBZSZJUzSawITqTNfbHDsGmryvfoAoTbGSlzPUqxYtdt0ZhHIJEK_n0r8mTGWfeHi-dWCkeg3KQKhpbbc5wM9ZuU9oIE-guSQuh0F9IXSOij1UQgvgWBq7FmUsd8woZX1y2XKP99IE9-QxXyMc-OVSugAu3CqVBJkg_8WBa6Y4dY8Dg9BupzIDDEMjkMrG8Z4nAK-jR_T9yv4UpJGeS470M-1c3a-zPdfBIhY-ACz1BNXCODgq0l3LA4ZWO8QewfuZvANXnZQSOdm-RGs6eXqIuvMM6kHU5_iTSAuEVRMAZrUag3YBmyLzRfELUXipDq-4-iMBY_2BDH9QvA8Lps0QFF-dLpJIh1KU2mCKHmHpBk6vLRL16il41HEK1dk-HVoAVl9WwEEKIoSchWAqiXtWMS1b8kXjNX8-RHQSsCaJcmJsW5ijeYjMPg7My4U64AE_c6v2HtP1k787uQa_abiTXD6kfpE-EDQUp2LKudKaXlDJcDP2NfJRUWFjcI0PAL-xPcFU3hJXABTURvdu1a8ZCfm8s6tZ02d9CLOCq8znsTXCa4Sh1pjOHs6xB96KpJpUbrWn2GRflD06cyO1BwQRdmeIg5K3hL1APhD5cSjMttWZw-j7bKQasL4WT9mXLHJYi-kuxYdbBm74WkKXM2cpncHBug7PUnx1ZVJnMKz0TH65fA6pts2ljMh2gdofzdPjIHM8a3BRI5vjClnR9_-D_LqtRJSo2UQU0MHbon1v90cHGujbd66FMFSifp-1zCzzvagtO9mBMMlb1i7LqT_Z6XNyxkRHl8szr9GYREubcu8drislf7B5U-HVdgCzakCx5UQ1JU1uoptWlfNOBKrS1pR.Mog0PfDD7dp8swfY9zUG1w",
// "deviceKey": "eu-central-1_6418bd3a-277e-43b5-88be-5ca7c98e0f4c"

import { IFleetKarhoo, ITripSelectedDetails } from "models/TripInterface";
import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { removeItemStorage, setItemStorage } from "services/util/sessionStorage.service";

export function initSession() {
    return window.sessionStorage[SessionStorageItems.SESSION_TOKEN]
        ? {
            deviceKey: window.localStorage[LocalStorageItems.DEVICE_KEY],
            sessionToken: window.sessionStorage[SessionStorageItems.SESSION_TOKEN],
            refreshToken: window.sessionStorage[SessionStorageItems.REFRESH_TOKEN],
        }
        : null
}

export function initUserDetail() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_USER_DETAIL];
    return detail ? JSON.parse(detail) : null;
}

export function initTripSummaryDetail() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_TRIP_SUMMARY_DETAIL];
    return detail ? JSON.parse(detail) : null;
}

export function initReturnTripSummaryDetail() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_RETURN_TRIP_SUMMARY_DETAIL];
    return detail ? JSON.parse(detail) : null;
}

export function initFleetKarhooName() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_FLEET_KARHOO_NAME];
    return detail ? JSON.parse(detail) : null;
}
export function initTMBSummaryDetail() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_TMB_SUMMARY_DETAIL];
    return detail ? JSON.parse(detail) : null;
}

export function initTypeTrip() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_TYPE_TRIP];
    return detail ? JSON.parse(detail) : null;
}

export function initActivityGlobick() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_ACTIVITY_GLOBICK];
    return detail ? JSON.parse(detail) : null;
}

export function initBookingGlobick() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_BOOKING_GLOBICK];
    return detail ? JSON.parse(detail) : null;
}

export function initTokenGlobick() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_TOKEN_GLOBICK];
    return detail ? detail: null;
}

export function initPostTokenGlobick() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_POST_BOOKING_GLOBICK];
    return detail ? detail: null;
}

export function initbodyLongMover() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_BODY_LONGMOVER];
    return detail ? JSON.parse(detail): null;
}

export function initConfimedTarifs() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_BODY_LONGMOVER];
    return detail ? JSON.parse(detail): null;
}

export function initTokenVeridas() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_TOKEN_VERIDAS];
    return detail ? JSON.parse(detail): null;
}
export function initNextToMeData() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_NEXT_TO_ME_DATA];
    return detail ? JSON.parse(detail): null;
}








export function setTMBSummaryDetail(data: any) {
    setItemStorage(SessionStorageItems.RAAS_TMB_SUMMARY_DETAIL, data);
}
export function removeTMBSummaryDetail() {
    removeItemStorage(SessionStorageItems.RAAS_TMB_SUMMARY_DETAIL);
}

export function setTripSummaryDetail(data: ITripSelectedDetails) {
    setItemStorage(SessionStorageItems.RAAS_TRIP_SUMMARY_DETAIL, data);
}

export function setReturnTripSummaryDetail(data: ITripSelectedDetails) {
    setItemStorage(SessionStorageItems.RAAS_RETURN_TRIP_SUMMARY_DETAIL, data);
}

export function setUserDetail(data: any) {
    setItemStorage(SessionStorageItems.RAAS_USER_DETAIL, data);
}

export function setFleetSessionName(data: IFleetKarhoo) {
    setItemStorage(SessionStorageItems.RAAS_FLEET_KARHOO_NAME, data);
}

export function setCardTypeTitles(data: string) {
    setItemStorage(SessionStorageItems.RAAS_CARD_TYPE_TITLES, data);
}

export function setTmbActivitySelected(data: any) {
    setItemStorage(SessionStorageItems.RAAS_TMB_ACTIVITY_SELECTED, data);
}
export function setTypeSelectedTrip(data: any) {
    setItemStorage(SessionStorageItems.RAAS_TYPE_TRIP, data);
}
export function setActivityGlobick(data: any) {
    setItemStorage(SessionStorageItems.RAAS_ACTIVITY_GLOBICK, data);
}

export function setBookingGlobick(data: any) {
    setItemStorage(SessionStorageItems.RAAS_BOOKING_GLOBICK, data);
}

export function setPostBookingGlobick(data: any) {
    setItemStorage(SessionStorageItems.RAAS_POST_BOOKING_GLOBICK, data);
}

export function setTokenGlobick(data: any) {
    setItemStorage(SessionStorageItems.RAAS_TOKEN_GLOBICK, data);
}

export function setBodyLongMover(data: any) {
    setItemStorage(SessionStorageItems.RAAS_BODY_LONGMOVER, data);
}

export function setSaveTabs(data: any) {
    setItemStorage(SessionStorageItems.RAAS_SAVE_TABS, data);
}

export function setOffSite(data: any) {
    setItemStorage(SessionStorageItems.RAAS_OFF_SITE, data);
}

export function setDataCodePromoSession(data: any) {
    setItemStorage(SessionStorageItems.RAAS_DATA_CODE_PROMO, data);
}

export function setPayCit(data: any) {
    setItemStorage(SessionStorageItems.RAAS_PAY_CIT, data);
}

export function setTypeCit(data: any) {
    setItemStorage(SessionStorageItems.RAAS_TYPE_CIT, data);
}

export function setConfirmationRedsys(data: any) {
    setItemStorage(SessionStorageItems.RAAS_CONFIRMATION_REDSYS, data);
}


export function setAnyPay(data: any) {
    setItemStorage(SessionStorageItems.RAAS_ANY_PAID, data);
}
export function setPolicy(data: any) {
    setItemStorage(SessionStorageItems.RAAS_POLICY, data);
}
export function setConfirmedTarifsSession(data: any) {
    setItemStorage(SessionStorageItems.RAAS_CONFIRMED_TARIFS, data);
}

export function setAcceptedPolitical(data: any) {
    setItemStorage(SessionStorageItems.RAAS_ACCEPTED_POLITICAL, data);
}





export function getTmbActivitySelected() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_TMB_ACTIVITY_SELECTED];
    return detail ? JSON.parse(detail) : null;
}

export function setIdTmbSelect(data: any) {
    setItemStorage(SessionStorageItems.RAAS_ID_TMB_SELECT, data);
}

export function getIdTmbSelect() {
    return sessionStorage.getItem(SessionStorageItems.RAAS_ID_TMB_SELECT) || '';
}
export function getTripSummaryDetail() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_TRIP_SUMMARY_DETAIL];
    return detail ? JSON.parse(detail) : null;

}
export function getTokenGlobickSession() {
    return sessionStorage.getItem(SessionStorageItems.RAAS_TOKEN_GLOBICK) || '';
}
export function getConfirmedTarifsSession() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_CONFIRMED_TARIFS];
    return detail ? JSON.parse(detail) : null;

}




export function closeSession() {
    setStorage();
}

export function refreshSession() {
    const body = {
        sessionToken: getToken(),
        refreshToken: getRefreshToken(),
        deviceKey: getDeviceKey()
    }
    return new Promise((resolve, reject) => {
        postAxios(apiNames.IDENTITY, false, "/sessions/refresh-token", body)
            .then((data: any) => {
                setStorage(data?.data as RaaSSession)
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            })
    })
}

export function initstepOnBoarding() {
    return window.sessionStorage[SessionStorageItems.RAAS_STEP_ON_BOARDING_FLOW] ? true : false;
}

export function initLogged() {
    return window.sessionStorage[SessionStorageItems.SESSION_TOKEN] ? true : false;
}
export function checkLoggedSocialStorage() {
    return Boolean(localStorage.getItem('amplify-redirected-from-hosted-ui')) && Boolean(Object.keys(localStorage).find(item => item.includes('CognitoIdentityServiceProvider')));
}
export function isRedirectionByAmplifyLogin() {
    return window.location.pathname === "/app/" && Boolean(localStorage.getItem('amplify-redirected-from-hosted-ui') && Boolean(sessionStorage.getItem('current-page')))
}

export function initOffSite() {
    let result=false;
    if(window.sessionStorage[SessionStorageItems.RAAS_OFF_SITE]==="true"  || window.sessionStorage[SessionStorageItems.RAAS_OFF_SITE]===true ){
        result=true
    }
    return result;
}

export function initDataCodePromo() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_DATA_CODE_PROMO];
    return detail ? JSON.parse(detail) : null;
}



export function getCurrentRedirection(){
    return sessionStorage.getItem('current-page') || '';
}

export function getToken() {
    return window.sessionStorage[SessionStorageItems.SESSION_TOKEN];
}
export function getRefreshToken() {
    return window.sessionStorage[SessionStorageItems.REFRESH_TOKEN];
}

export function getUserDetail() {
    let result;
    if (window.sessionStorage[SessionStorageItems.RAAS_USER_DETAIL]) {
        result = JSON.parse((window.sessionStorage[SessionStorageItems.RAAS_USER_DETAIL]));
    } else {
        result = null;
    }
    return result
}

export function getDeviceKey() {
    return window.localStorage && window.localStorage[LocalStorageItems.DEVICE_KEY] ? window.localStorage[LocalStorageItems.DEVICE_KEY] : null;
}

export function getCardTypeTitles() {
    return window.sessionStorage[SessionStorageItems.RAAS_CARD_TYPE_TITLES];
}

export function getPostBookingGlobick() {
    let result;
    if (window.sessionStorage[SessionStorageItems.RAAS_POST_BOOKING_GLOBICK]) {
        result = JSON.parse((window.sessionStorage[SessionStorageItems.RAAS_POST_BOOKING_GLOBICK]));
    } else {
        result = null;
    }
    return result
}

export function getReturnPointSixt() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_SIXT_RETURN_POINT];
    return detail ? JSON.parse(detail) : null;
}

export function getBodyLongMover() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_BODY_LONGMOVER];
    return detail ? JSON.parse(detail) : null;
}

export function setReturnPointSelected(data: any) {
    setItemStorage(SessionStorageItems.RAAS_SIXT_RETURN_POINT, data);
}

export function setToken(data: any) {
    setItemStorage(SessionStorageItems.SESSION_TOKEN, data);
}

export function getSaveTabs() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_SAVE_TABS];
    return detail ? JSON.parse(detail) : null;
}
export function getOffSite() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_OFF_SITE];
    return detail ? JSON.parse(detail) : null;
}

export function getDataCodePromo() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_DATA_CODE_PROMO];
    return detail ? JSON.parse(detail) : null;
}
export function getPayCit() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_PAY_CIT];
    return detail ? JSON.parse(detail) : null;
}

export function getTypeCit() {
    return window.sessionStorage[SessionStorageItems.RAAS_TYPE_CIT];
    /*let detail = window.sessionStorage[SessionStorageItems.RAAS_TYPE_CIT];
    return detail ? JSON.parse(detail) : null;*/
}

export function getConfirmationRedsys() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_CONFIRMATION_REDSYS];
    return detail ? JSON.parse(detail) : null;
}

export function getAnyPaid() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_ANY_PAID];
    return detail ? JSON.parse(detail) : false;
}

export function getPolicy() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_POLICY];
    return detail ? JSON.parse(detail) : false;
}


export function getAcceptedPolitical() {
    let detail = window.sessionStorage[SessionStorageItems.RAAS_ACCEPTED_POLITICAL];
    return detail ? JSON.parse(detail) : null;
}











export function setStorage(data?: RaaSSession) {
    if (data) {
        window.localStorage[LocalStorageItems.DEVICE_KEY] = data.deviceKey;
        window.sessionStorage[SessionStorageItems.SESSION_TOKEN] = data.sessionToken;
        window.sessionStorage[SessionStorageItems.REFRESH_TOKEN] = data.refreshToken;
    } else {
        delete window.localStorage[LocalStorageItems.DEVICE_KEY];
        delete window.sessionStorage[SessionStorageItems.SESSION_TOKEN];
        delete window.sessionStorage[SessionStorageItems.REFRESH_TOKEN];
        window.sessionStorage.clear();
    }
}

export interface RaaSSession {
    sessionToken: string,
    refreshToken: string,
    deviceKey: string
}

export enum LocalStorageItems {
    DEVICE_KEY = "raas-device-key",
}

export enum SessionStorageItems {
    ID_TOKEN = "raas-id-token",
    SESSION_TOKEN = "raas-session-token",
    REFRESH_TOKEN = "raas-refresh-token",
    TRIP = "raas-trip-planning",
    RAAS_USER = "raas-user",
    RAAS_USER_DETAIL = "raas-user-detail",
    RAAS_TRIP_SUMMARY_DETAIL = "raas-trip-summary-detail",
    RAAS_RETURN_TRIP_SUMMARY_DETAIL = "raas-return-trip-summary-detail",
    RAAS_FLEET_KARHOO_NAME = "raas-fleet-karhoo-name",
    RAAS_LANGUAGE = "raas-language",
    RAAS_STEP_ON_BOARDING_FLOW = "raas_step_on_boarding_flow",
    RAAS_PST_CANCELLED_RECENTLY = "raas-pst-cancelled-recently",
    RAAS_RETURN_FROM_TO_AVE = "raas-return-from-to-ave",
    RAAS_RETURN_FROM_TO_ROUTE_BOX = "raas-return-from-to_route_box",
    RAAS_CARD_TYPE_TITLES="raas-card-type-titles",
    RAAS_ID_TMB_SELECT='raas-id-tmb-select',
    RAAS_TMB_ACTIVITY_SELECTED='raas-activity-selected',
    RAAS_TMB_SUMMARY_DETAIL = "raas-tmb-summary-detail",
    RAAS_TYPE_TRIP="raas-trype-trip",
    RAAS_ACTIVITY_GLOBICK="raas-activity-globick",
    RAAS_BOOKING_GLOBICK="raas-booking-globick",
    RAAS_TOKEN_GLOBICK="raas-token-globick",
    RAAS_POST_BOOKING_GLOBICK="raas-post-booking-globick",
    RAAS_SIXT_RETURN_POINT ="raas-sixt-return-point",
    RAAS_BODY_LONGMOVER="raas-body-longmover",
    RAAS_SAVE_TABS="raas-save-tabs",
    RAAS_OFF_SITE="raas-off-site",
    RAAS_DATA_CODE_PROMO="raas-data-code-promo",
    RAAS_PAY_CIT="raas-pay-cit",
    RAAS_TYPE_CIT="raas-type-cit",
    RAAS_CONFIRMATION_REDSYS="raas-confirmation-redsys",
    RAAS_ANY_PAID="raas-any-paid",
    RAAS_POLICY="raas-policy",
    RAAS_CONFIRMED_TARIFS="raas-confirmed-tarifs",
    RAAS_ACCEPTED_POLITICAL="raas-accepted-political",
    RAAS_TOKEN_VERIDAS="raas-token-veridas",
    RAAS_PAYMENT_METHODS="raas-payment-methods",
    RAAS_NEXT_TO_ME_DATA="raas-next-to-me-data",


}

export interface ICustomerFullName {
    name: string;
    firstSurname: string;
    secondSurname: string;
}

export interface IIdentificationDocument {
    type: string;
    value: string;
}

export interface IPhone {
    prefix: string;
    number: string;
}

export interface OptimalRoute {
    type: string;
    enabled: boolean;
}

export interface FavouriteTransport {
    type: string;
    enabled: boolean;
}

export interface Route {
    type: string;
    enabled: boolean;
}

export interface IPreferences {
    optimalRoutes: OptimalRoute[];
    favouriteTransports: FavouriteTransport[];
    routes: Route[];
}

export interface IUserData {
    customerId: string;
    customerIdAccount?: any;
    missingMandatoryInfo: boolean;
    customerFullName: ICustomerFullName;
    identificationDocument: IIdentificationDocument;
    email: string;
    phone: IPhone;
    birthDate: string;
    under16: boolean;
    profileImage?: any;
    addresses: any[];
    preferences: IPreferences;
    docs: any[];
    payment: { customerAllowed: string | boolean }
}
